import { useMutation, useQueryClient } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { updateAdminFinRequest } from "../Services/updateAdminFinRequest";

export default function useBulkUpdateAdminFinMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: ({ selectedIds, dataHistory, userNickname }) => {
      const promises = selectedIds.map((id) => {
        const row = dataHistory.find((item) => item.id === id);
        const updatedRow = {
          ...row,
          estado: 4,
          update_timestamp: new Date().toISOString(),
          userNickname,
        };
        return updateAdminFinRequest({ row: updatedRow, accessToken });
      });
      return Promise.all(promises);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["serviceOperation", "adminData"] });
    },
  });
}
